<template>
	<div id="loader">
		<svg viewBox="0 0 1 1" preserveAspectRatio="none">
			<defs>
				<clipPath id="loaderClipPath" clipPathUnits="objectBoundingBox">
					<path :d="path"/>
				</clipPath>
				<clipPath id="loaderClipPathBackground" clipPathUnits="objectBoundingBox">
					<path :d="backgroundPath"/>
				</clipPath>
			</defs>
		</svg>
		<div class="background" ref="background"></div>
		<div class="center-wrapper">
			<div class="titles" v-for="word in words" :key="word" ref="words">
				<div :class="['title', i === 2 ? 'clone' : '']" ref="title" v-for="i in 2" :key="i">
					<div class="word">
						<span class="initial" v-for="(letter, j) in word" v-html="letter" :key="j"></span>
					</div>
				</div>
			</div>
			<!-- <div class="🤓" ref="subtitle">
				Front-end developer
			</div> -->
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			endOfTl: false,
			progression: 1,
			easedProgression: 1,
			backgroundProgression: 1,
			backgroundEasedProgression: 1,
			words: [
				'Front-end',
				'Development',
				'Interaction',
				'Motion'
			]
		}
	},
	computed: {
		loaded: function() {
			return this.$store.getters['ui/isContentLoaded'];
		},
		path: function() {
			return `
				M 1,0
				L 1,${this.progression}
				C 0.75,${this.easedProgression} 0.25,${this.easedProgression} 0,${this.progression}
				L 0,0
			`
		},
		backgroundPath: function() {
			return `
				M 1,1
				L 0,1
				L 0,${this.backgroundProgression}
				C 0.25,${this.backgroundEasedProgression} 0.75,${this.backgroundEasedProgression} 1,${this.backgroundProgression}
			`
		}
	},
	watch: {
		'endOfTl': function(endOfTl) {
			if (endOfTl && this.loaded) {
				this.closeLoader()
			}
		},
		'loaded': function(loaded) {
			if (this.endOfTl && loaded) {
				this.closeLoader()
			}
		}
	},
	mounted() {
		this.$store.dispatch('ui/blockOverflow')
		this.showTimeline()
	},
	methods: {
		showTimeline(duration = 1) {
			const tl = new TimelineMax({
				delay: duration * 0.6,
				onComplete: () => {
					setTimeout(() => {
						this.endOfTl = true
					}, duration * 300);
				}
			})
			this.$refs.words.forEach((word, i) => {
				tl.staggerTo(word.querySelectorAll('span'), 0.6, {
					yPercent: 0,
					y: 0,
					ease: Power4.easeOut,
					overwrite: 'preexisting'
				}, 0.02, i === 0 ? 0 : '-=0.7')
			})
		},
		closeLoader(duration = 0.8) {
			const fadeOutTl = new TimelineMax({
				onComplete: () => {
					TweenMax.set(this.$el, {
						display: 'none'
					})
				}
			})
			fadeOutTl
			.to(this, 0.8 * duration, {
				backgroundProgression: 0,
				ease: Power4.easeInOut
			})
			.to(this, 1 * duration, {
				backgroundEasedProgression: 0,
				ease: Power4.easeOut
			}, 0)
			.add('secondPath', '-=' + (0.6 * duration))
			.to(this, 0.8 * duration, {
				progression: 0,
				ease: Power4.easeInOut
			}, 'secondPath')
			.to(this, 1 * duration, {
				easedProgression: 0,
				ease: Power4.easeOut
			}, 'secondPath')
			.add(() => {
				this.$store.dispatch('ui/loaderIsHidden')
			}, duration / 1.5)
		}
	}
};
</script>
<style lang="sass">
#loader
	position: fixed
	z-index: 11
	top: 0
	left: 0
	width: 100%
	height: 100vh
	display: flex
	justify-content: center
	align-items: center
	flex-direction: column
	background: white
	clip-path: url(#loaderClipPath)
	@media screen and (max-width: 414px)
		height: 100%
	.background
		position: absolute
		top: 0
		left: 0
		width: 100%
		height: 100%
		z-index: 1
		background: black
		clip-path: url(#loaderClipPathBackground)
	svg
		position: absolute
		height: 100%
		width: 100%
		z-index: 0
	.center-wrapper
		text-align: left
		.titles
			position: relative
			z-index: 2
			.title
				font-family: var(--serif)
				color: transparent
				font-size: 3vw
				line-height: 1.25
				margin: auto
				display: inline-block
				clip-path: polygon(calc(var(--title-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--title-x) * 1%) 100%)
				z-index: 2
				.word
					display: block
					white-space: nowrap
					overflow: hidden
					span
						vertical-align: middle
						-webkit-text-stroke: 0.01em #fff
						text-stroke: 0.01em #fff
						display: inline-block
						transform: translateY(100%)
				&.clone
					position: absolute
					top: 0
					left: 0
					white-space: nowrap
					color: #000
					clip-path: polygon(0% 0%, calc(var(--title-x) * 1%) 0%, calc(var(--title-x) * 1%) 100%, 0% 100%)
		.🤓
			margin-top: 2rem
			position: relative
			z-index: 0
			color: #666
			font-size: 1.7vw
			clip-path: polygon(calc(var(--subtitle-x) * 1%) 0%, 100% 0%, 100% 100%, calc(var(--subtitle-x) * 1%) 100%)
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue